module.exports = __webpack_public_path__ + "img/payments.65d89ed.webp";